"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.API_NAME = void 0;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _flow2 = _interopRequireDefault(require("lodash/flow"));

var _netlifyCmsLibUtil = require("netlify-cms-lib-util");

var _commonTags = require("common-tags");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n        source.repository.full_name = \"", "\" \n        AND state = \"", "\" \n        AND destination.branch.name = \"", "\"\n        AND comment_count > 0\n        AND ", "\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BitBucketPullRequestState;

(function (BitBucketPullRequestState) {
  BitBucketPullRequestState["MERGED"] = "MERGED";
  BitBucketPullRequestState["SUPERSEDED"] = "SUPERSEDED";
  BitBucketPullRequestState["OPEN"] = "OPEN";
  BitBucketPullRequestState["DECLINED"] = "DECLINED";
})(BitBucketPullRequestState || (BitBucketPullRequestState = {}));

var BitBucketPullRequestStatusState;

(function (BitBucketPullRequestStatusState) {
  BitBucketPullRequestStatusState["Successful"] = "SUCCESSFUL";
  BitBucketPullRequestStatusState["Failed"] = "FAILED";
  BitBucketPullRequestStatusState["InProgress"] = "INPROGRESS";
  BitBucketPullRequestStatusState["Stopped"] = "STOPPED";
})(BitBucketPullRequestStatusState || (BitBucketPullRequestStatusState = {}));

const API_NAME = 'BitBucket';
exports.API_NAME = API_NAME;
const APPLICATION_JSON = 'application/json; charset=utf-8';

const replace404WithEmptyResponse = err => {
  if (err && err.status === 404) {
    console.log('This 404 was expected and handled appropriately.');
    return {
      size: 0,
      values: []
    };
  } else {
    return Promise.reject(err);
  }
};

class API {
  constructor(config) {
    var _this = this;

    _defineProperty(this, "apiRoot", void 0);

    _defineProperty(this, "branch", void 0);

    _defineProperty(this, "repo", void 0);

    _defineProperty(this, "requestFunction", void 0);

    _defineProperty(this, "repoURL", void 0);

    _defineProperty(this, "commitAuthor", void 0);

    _defineProperty(this, "mergeStrategy", void 0);

    _defineProperty(this, "initialWorkflowStatus", void 0);

    _defineProperty(this, "buildRequest", req => (0, _flow2.default)([_netlifyCmsLibUtil.unsentRequest.withRoot(this.apiRoot), _netlifyCmsLibUtil.unsentRequest.withTimestamp])(req));

    _defineProperty(this, "request", req => (0, _flow2.default)([this.buildRequest, this.requestFunction, p => p.catch(err => Promise.reject(new _netlifyCmsLibUtil.APIError(err.message, null, API_NAME)))])(req));

    _defineProperty(this, "responseToJSON", (0, _netlifyCmsLibUtil.responseParser)({
      format: 'json',
      apiName: API_NAME
    }));

    _defineProperty(this, "responseToBlob", (0, _netlifyCmsLibUtil.responseParser)({
      format: 'blob',
      apiName: API_NAME
    }));

    _defineProperty(this, "responseToText", (0, _netlifyCmsLibUtil.responseParser)({
      format: 'text',
      apiName: API_NAME
    }));

    _defineProperty(this, "requestJSON", req => this.request(req).then(this.responseToJSON));

    _defineProperty(this, "requestText", req => this.request(req).then(this.responseToText));

    _defineProperty(this, "user", () => this.requestJSON('/user'));

    _defineProperty(this, "hasWriteAccess", async () => {
      const response = await this.request(this.repoURL);

      if (response.status === 404) {
        throw Error('Repo not found');
      }

      return response.ok;
    });

    _defineProperty(this, "branchCommitSha", async branch => {
      const {
        target: {
          hash: branchSha
        }
      } = await this.requestJSON("".concat(this.repoURL, "/refs/branches/").concat(branch));
      return branchSha;
    });

    _defineProperty(this, "isFile", (_ref) => {
      let {
        type
      } = _ref;
      return type === 'commit_file';
    });

    _defineProperty(this, "processFile", file => _objectSpread({
      id: file.id,
      type: file.type,
      path: file.path,
      name: (0, _netlifyCmsLibUtil.basename)(file.path)
    }, file.commit && file.commit.hash ? {
      id: "".concat(file.commit.hash, "/").concat(file.path)
    } : {}));

    _defineProperty(this, "processFiles", files => files.filter(this.isFile).map(this.processFile));

    _defineProperty(this, "readFile", async function (path, sha) {
      let {
        parseText = true,
        branch = _this.branch
      } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      const fetchContent = async () => {
        const node = await _this.branchCommitSha(branch);
        const content = await _this.request({
          url: "".concat(_this.repoURL, "/src/").concat(node, "/").concat(path),
          cache: 'no-store'
        }).then(parseText ? _this.responseToText : _this.responseToBlob);
        return content;
      };

      const content = await (0, _netlifyCmsLibUtil.readFile)(sha, fetchContent, _netlifyCmsLibUtil.localForage, parseText);
      return content;
    });

    _defineProperty(this, "getEntriesAndCursor", jsonResponse => {
      const {
        size: count,
        page: index,
        pagelen: pageSize,
        next,
        previous: prev,
        values: entries
      } = jsonResponse;
      const pageCount = pageSize && count ? Math.ceil(count / pageSize) : undefined;
      return {
        entries,
        cursor: _netlifyCmsLibUtil.Cursor.create({
          actions: [...(next ? ['next'] : []), ...(prev ? ['prev'] : [])],
          meta: {
            index,
            count,
            pageSize,
            pageCount
          },
          data: {
            links: {
              next,
              prev
            }
          }
        })
      };
    });

    _defineProperty(this, "listFiles", async function (path) {
      let depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      const node = await _this.branchCommitSha(_this.branch);
      const result = await _this.requestJSON({
        url: "".concat(_this.repoURL, "/src/").concat(node, "/").concat(path),
        params: {
          // sort files by filename ascending
          sort: '-path',
          // eslint-disable-next-line @typescript-eslint/camelcase
          max_depth: depth
        }
      }).catch(replace404WithEmptyResponse);

      const {
        entries,
        cursor
      } = _this.getEntriesAndCursor(result);

      return {
        entries: _this.processFiles(entries),
        cursor: cursor
      };
    });

    _defineProperty(this, "traverseCursor", async (cursor, action) => (0, _flow2.default)([this.requestJSON, (0, _netlifyCmsLibUtil.then)(this.getEntriesAndCursor), (0, _netlifyCmsLibUtil.then)((_ref2) => {
      let {
        cursor: newCursor,
        entries
      } = _ref2;
      return {
        cursor: newCursor,
        entries: this.processFiles(entries)
      };
    })])(cursor.data.getIn(['links', action])));

    _defineProperty(this, "listAllFiles", async function (path) {
      let depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      const {
        cursor: initialCursor,
        entries: initialEntries
      } = await _this.listFiles(path, depth);
      const entries = [...initialEntries];
      let currentCursor = initialCursor;

      while (currentCursor && currentCursor.actions.has('next')) {
        const {
          cursor: newCursor,
          entries: newEntries
        } = await _this.traverseCursor(currentCursor, 'next');
        entries.push(...newEntries);
        currentCursor = newCursor;
      }

      return _this.processFiles(entries);
    });

    _defineProperty(this, "deleteFile", (path, message) => {
      const body = new FormData();
      body.append('files', path);
      body.append('branch', this.branch);

      if (message) {
        body.append('message', message);
      }

      if (this.commitAuthor) {
        const {
          name,
          email
        } = this.commitAuthor;
        body.append('author', "".concat(name, " <").concat(email, ">"));
      }

      return (0, _flow2.default)([_netlifyCmsLibUtil.unsentRequest.withMethod('POST'), _netlifyCmsLibUtil.unsentRequest.withBody(body), this.request])("".concat(this.repoURL, "/src"));
    });

    this.apiRoot = config.apiRoot || 'https://api.bitbucket.org/2.0';
    this.branch = config.branch || 'master';
    this.repo = config.repo || '';
    this.requestFunction = config.requestFunction || _netlifyCmsLibUtil.unsentRequest.performRequest; // Allow overriding this.hasWriteAccess

    this.hasWriteAccess = config.hasWriteAccess || this.hasWriteAccess;
    this.repoURL = this.repo ? "/repositories/".concat(this.repo) : '';
    this.mergeStrategy = config.squashMerges ? 'squash' : 'merge_commit';
    this.initialWorkflowStatus = config.initialWorkflowStatus;
  }

  async uploadFiles(files, _ref3) {
    let {
      commitMessage,
      branch,
      parentSha
    } = _ref3;
    const formData = new FormData();
    files.forEach(file => {
      if (file.delete) {
        // delete the file
        formData.append('files', file.path);
      } else {
        // add/modify the file
        const contentBlob = (0, _get2.default)(file, 'fileObj', new Blob([file.raw])); // Third param is filename header, in case path is `message`, `branch`, etc.

        formData.append(file.path, contentBlob, (0, _netlifyCmsLibUtil.basename)(file.path));
      }
    });

    if (commitMessage) {
      formData.append('message', commitMessage);
    }

    if (this.commitAuthor) {
      const {
        name,
        email
      } = this.commitAuthor;
      formData.append('author', "".concat(name, " <").concat(email, ">"));
    }

    formData.append('branch', branch);

    if (parentSha) {
      formData.append('parents', parentSha);
    }

    await this.request({
      url: "".concat(this.repoURL, "/src"),
      method: 'POST',
      body: formData
    });
    return files;
  }

  async persistFiles(entry, mediaFiles, options) {
    const files = entry ? [entry, ...mediaFiles] : mediaFiles;

    if (options.useWorkflow) {
      return this.editorialWorkflowGit(files, entry, options);
    } else {
      return this.uploadFiles(files, {
        commitMessage: options.commitMessage,
        branch: this.branch
      });
    }
  }

  async addPullRequestComment(pullRequest, comment) {
    await this.requestJSON({
      method: 'POST',
      url: "".concat(this.repoURL, "/pullrequests/").concat(pullRequest.id, "/comments"),
      headers: {
        'Content-Type': APPLICATION_JSON
      },
      body: JSON.stringify({
        content: {
          raw: comment
        }
      })
    });
  }

  async getPullRequestLabel(id) {
    const comments = await this.requestJSON({
      url: "".concat(this.repoURL, "/pullrequests/").concat(id, "/comments"),
      params: {
        pagelen: 100
      }
    });
    return comments.values.map(c => c.content.raw)[comments.values.length - 1];
  }

  async createPullRequest(branch, commitMessage, status) {
    const pullRequest = await this.requestJSON({
      method: 'POST',
      url: "".concat(this.repoURL, "/pullrequests"),
      headers: {
        'Content-Type': APPLICATION_JSON
      },
      body: JSON.stringify({
        title: commitMessage,
        source: {
          branch: {
            name: branch
          }
        },
        destination: {
          branch: {
            name: this.branch
          }
        },
        description: _netlifyCmsLibUtil.DEFAULT_PR_BODY,
        // eslint-disable-next-line @typescript-eslint/camelcase
        close_source_branch: true
      })
    }); // use comments for status labels

    await this.addPullRequestComment(pullRequest, (0, _netlifyCmsLibUtil.statusToLabel)(status));
  }

  async getDifferences(branch) {
    const diff = await this.requestJSON({
      url: "".concat(this.repoURL, "/diffstat/").concat(branch, "..").concat(this.branch),
      params: {
        pagelen: 100
      }
    });
    return diff.values;
  }

  async editorialWorkflowGit(files, entry, options) {
    const contentKey = this.generateContentKey(options.collectionName, entry.slug);
    const branch = this.branchFromContentKey(contentKey);
    const unpublished = options.unpublished || false;

    if (!unpublished) {
      const defaultBranchSha = await this.branchCommitSha(this.branch);
      await this.uploadFiles(files, {
        commitMessage: options.commitMessage,
        branch,
        parentSha: defaultBranchSha
      });
      await this.createPullRequest(branch, options.commitMessage, options.status || this.initialWorkflowStatus);
    } else {
      // mark files for deletion
      const diffs = await this.getDifferences(branch);
      const toDelete = [];

      for (const diff of diffs) {
        if (!files.some(file => file.path === diff.new.path)) {
          toDelete.push({
            path: diff.new.path,
            delete: true
          });
        }
      }

      await this.uploadFiles([...files, ...toDelete], {
        commitMessage: options.commitMessage,
        branch
      });
    }
  }

  generateContentKey(collectionName, slug) {
    return (0, _netlifyCmsLibUtil.generateContentKey)(collectionName, slug);
  }

  contentKeyFromBranch(branch) {
    return branch.substring("".concat(_netlifyCmsLibUtil.CMS_BRANCH_PREFIX, "/").length);
  }

  branchFromContentKey(contentKey) {
    return "".concat(_netlifyCmsLibUtil.CMS_BRANCH_PREFIX, "/").concat(contentKey);
  }

  async isFileExists(path, branch) {
    const fileExists = await this.readFile(path, null, {
      branch
    }).then(() => true).catch(error => {
      if (error instanceof _netlifyCmsLibUtil.APIError && error.status === 404) {
        return false;
      }

      throw error;
    });
    return fileExists;
  }

  async getPullRequests(sourceBranch) {
    const sourceQuery = sourceBranch ? "source.branch.name = \"".concat(sourceBranch, "\"") : "source.branch.name ~ \"".concat(_netlifyCmsLibUtil.CMS_BRANCH_PREFIX, "/\"");
    const pullRequests = await this.requestJSON({
      url: "".concat(this.repoURL, "/pullrequests"),
      params: {
        pagelen: 50,
        q: (0, _commonTags.oneLine)(_templateObject(), this.repo, BitBucketPullRequestState.OPEN, this.branch, sourceQuery)
      }
    });
    const labels = await Promise.all(pullRequests.values.map(pr => this.getPullRequestLabel(pr.id)));
    return pullRequests.values.filter((_, index) => (0, _netlifyCmsLibUtil.isCMSLabel)(labels[index]));
  }

  async getBranchPullRequest(branch) {
    const pullRequests = await this.getPullRequests(branch);

    if (pullRequests.length <= 0) {
      throw new _netlifyCmsLibUtil.EditorialWorkflowError('content is not under editorial workflow', true);
    }

    return pullRequests[0];
  }

  async retrieveMetadata(contentKey) {
    var _diff$find;

    const {
      collection,
      slug
    } = (0, _netlifyCmsLibUtil.parseContentKey)(contentKey);
    const branch = this.branchFromContentKey(contentKey);
    const pullRequest = await this.getBranchPullRequest(branch);
    const diff = await this.getDifferences(branch);
    const path = (_diff$find = diff.find(d => d.new.path.includes(slug))) === null || _diff$find === void 0 ? void 0 : _diff$find.new.path; // TODO: get real file id

    const mediaFiles = await Promise.all(diff.filter(d => d.new.path !== path).map(d => ({
      path: d.new.path,
      id: null
    })));
    const label = await this.getPullRequestLabel(pullRequest.id);
    const status = (0, _netlifyCmsLibUtil.labelToStatus)(label);
    return {
      branch,
      collection,
      slug,
      path,
      status,
      mediaFiles
    };
  }

  async readUnpublishedBranchFile(contentKey) {
    const {
      branch,
      collection,
      slug,
      path,
      status,
      mediaFiles
    } = await this.retrieveMetadata(contentKey);
    const [fileData, isModification] = await Promise.all([this.readFile(path, null, {
      branch
    }), this.isFileExists(path, this.branch)]);
    return {
      slug,
      metaData: {
        branch,
        collection,
        objects: {
          entry: {
            path,
            mediaFiles
          }
        },
        status
      },
      fileData,
      isModification
    };
  }

  async listUnpublishedBranches() {
    console.log('%c Checking for Unpublished entries', 'line-height: 30px;text-align: center;font-weight: bold');
    const pullRequests = await this.getPullRequests();
    const branches = pullRequests.map(mr => mr.source.branch.name);
    return branches;
  }

  async updateUnpublishedEntryStatus(collection, slug, newStatus) {
    const contentKey = this.generateContentKey(collection, slug);
    const branch = this.branchFromContentKey(contentKey);
    const pullRequest = await this.getBranchPullRequest(branch);
    await this.addPullRequestComment(pullRequest, (0, _netlifyCmsLibUtil.statusToLabel)(newStatus));
  }

  async mergePullRequest(pullRequest) {
    await this.requestJSON({
      method: 'POST',
      url: "".concat(this.repoURL, "/pullrequests/").concat(pullRequest.id, "/merge"),
      headers: {
        'Content-Type': APPLICATION_JSON
      },
      body: JSON.stringify({
        message: _netlifyCmsLibUtil.MERGE_COMMIT_MESSAGE,
        // eslint-disable-next-line @typescript-eslint/camelcase
        close_source_branch: true,
        // eslint-disable-next-line @typescript-eslint/camelcase
        merge_strategy: this.mergeStrategy
      })
    });
  }

  async publishUnpublishedEntry(collectionName, slug) {
    const contentKey = this.generateContentKey(collectionName, slug);
    const branch = this.branchFromContentKey(contentKey);
    const pullRequest = await this.getBranchPullRequest(branch);
    await this.mergePullRequest(pullRequest);
  }

  async declinePullRequest(pullRequest) {
    await this.requestJSON({
      method: 'POST',
      url: "".concat(this.repoURL, "/pullrequests/").concat(pullRequest.id, "/decline")
    });
  }

  async deleteBranch(branch) {
    await this.request({
      method: 'DELETE',
      url: "".concat(this.repoURL, "/refs/branches/").concat(branch)
    });
  }

  async deleteUnpublishedEntry(collectionName, slug) {
    const contentKey = this.generateContentKey(collectionName, slug);
    const branch = this.branchFromContentKey(contentKey);
    const pullRequest = await this.getBranchPullRequest(branch);
    await this.declinePullRequest(pullRequest);
    await this.deleteBranch(branch);
  }

  async getPullRequestStatuses(pullRequest) {
    const statuses = await this.requestJSON({
      url: "".concat(this.repoURL, "/pullrequests/").concat(pullRequest.id, "/statuses"),
      params: {
        pagelen: 100
      }
    });
    return statuses.values;
  }

  async getStatuses(collectionName, slug) {
    const contentKey = this.generateContentKey(collectionName, slug);
    const branch = this.branchFromContentKey(contentKey);
    const pullRequest = await this.getBranchPullRequest(branch);
    const statuses = await this.getPullRequestStatuses(pullRequest);
    return statuses.map((_ref4) => {
      let {
        key,
        state,
        url
      } = _ref4;
      return {
        context: key,
        state: state === BitBucketPullRequestStatusState.Successful ? _netlifyCmsLibUtil.PreviewState.Success : _netlifyCmsLibUtil.PreviewState.Other,
        // eslint-disable-next-line @typescript-eslint/camelcase
        target_url: url
      };
    });
  }

}

exports.default = API;